const isProd = window.location.hostname === 'www.folksam.se';
const isAtst = window.location.hostname === 'atst.folksam.se';

/**
 * We created this solution because of IDIT migration.
 * The ids in STST and ATST needs to be updated every 3 months, so we added a json in our cms here:
 * Building blocks -> Content -> ReactApp Components -> product-banner -> Productbanner Service URLs
 * It uses the old id to get the new ones for IDIT.
 */
export const fetchIditIds = async () => {
    const data = await fetch('/media/idit-ids.json');
    const jsonData = await data?.json();
    if (isProd) return convertToMap(await jsonData?.prod);
    if (isAtst) return convertToMap(await jsonData?.atst);

    return convertToMap(await jsonData?.stst);
};

const convertToMap = iditIds =>
    iditIds.reduce((acc, union) => {
        const forbundsId = union?.forbundsId.toString().padStart(3, '0');

        acc.set(forbundsId, { groupId: union.IditGroupId, groupAgreementId: union.IditGroupAgreementId });
        return acc;
    }, new Map());
